'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAppReadyTrack = exports.addAppLoadTrack = exports.addClickTrack = exports.addEditTrack = exports.addNavigationTrack = exports.ClickTrackAction = undefined;

var _ScreenReducer = require('../components/screen/ScreenReducer');

var _ModuleReducer = require('../components/module/ModuleReducer');

var _StreamLogger = require('../services/StreamLogger');

var _Store = require('../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _CwLog = require('../services/CwLog');

var _CwLog2 = _interopRequireDefault(_CwLog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Enum for Click Track Action Type
 * @readonly
 * @enum {string}
 */
var ClickTrackAction = exports.ClickTrackAction = {
  EDIT: 'Edit',
  CLICK: 'Click',
  LEFT_CLICK: 'LeftClick',
  RIGHT_CLICK: 'RightClick',
  MIDDLE_CLICK: 'MiddleClick',
  NAVIGATION: 'Navigation',
  APP_LOAD: 'AppLoad',
  APP_READY: 'AppReady'
};

var getSource = function getSource() {
  var state = (0, _Store2.default)().getState();

  // use active screen key (if available) or default to ACTIVE_SCREEN_KEY
  var activeScreenKey = (0, _ModuleReducer.getActiveScreenKey)(state.module);

  return (0, _ScreenReducer.getScreenId)(state.screen, activeScreenKey);
};

/**
 * Creates and adds navigation tracker event for user navigations
 * @param {string} name 
 * @param {string} [source]
 */
var addNavigationTrack = exports.addNavigationTrack = function addNavigationTrack(name) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSource();

  if (!name) {
    _CwLog2.default.warn('Failed to log navigation track due to empty id name');
    return;
  }

  /** @type {ClickTrack} */
  var clickTrack = {
    name: name,
    action: ClickTrackAction.NAVIGATION,
    source: source
  };

  var useRecentsCache = false;
  (0, _StreamLogger.addClickTrackerEvent)(clickTrack, useRecentsCache);
};

/**
 * Creates and adds click tracker event for user edits
 * @param {string} name 
 * @param {string} [source]
 */
var addEditTrack = exports.addEditTrack = function addEditTrack(name) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSource();

  if (!name) {
    _CwLog2.default.warn('Failed to log field edit track due to empty id name');
    return;
  }

  /** @type {ClickTrack} */
  var clickTrack = {
    name: name,
    action: ClickTrackAction.EDIT,
    source: source
  };

  (0, _StreamLogger.addClickTrackerEvent)(clickTrack);
};

/**
 * Creates and adds click tracker event for user clicks
 * @param {string} name 
 * @param {string} [source]
 */
var addClickTrack = exports.addClickTrack = function addClickTrack(name) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSource();

  if (!name) {
    _CwLog2.default.warn('Failed to log click track due to empty id name');
    return;
  }

  /** @type {ClickTrack} */
  var clickTrack = {
    name: name,
    action: ClickTrackAction.CLICK,
    source: source
  };

  var useRecentsCache = false;
  (0, _StreamLogger.addClickTrackerEvent)(clickTrack, useRecentsCache);
};

/**
 * Creates and adds click tracker event for application load
 */
var addAppLoadTrack = exports.addAppLoadTrack = function addAppLoadTrack() {
  /** @type {ClickTrack} */
  var clickTrack = {
    name: window.location.href,
    action: ClickTrackAction.APP_LOAD,
    source: document.referrer
  };

  var useRecentsCache = false;
  (0, _StreamLogger.addClickTrackerEvent)(clickTrack, useRecentsCache);
  (0, _StreamLogger.sendLogs)(); // immediate send click track log before user exits
};

/**
 * Creates and adds click tracker event for everytime application is visited
 * Note that this can be fired multiple times for 1 user's load since oidc redirecting can trigger multiple refreshes
 */
var addAppReadyTrack = exports.addAppReadyTrack = function addAppReadyTrack() {
  /** @type {ClickTrack} */
  var clickTrack = {
    name: window.location.href,
    action: ClickTrackAction.APP_READY,
    source: document.referrer
  };

  var useRecentsCache = false;
  (0, _StreamLogger.addClickTrackerEvent)(clickTrack, useRecentsCache);
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/ClickTracker.js
// module id = 14
// module chunks = 10